import type { SearchSchemaInput } from '@tanstack/react-router';

/**
 * Which offboarding is open.
 *
 * No `tab` here, unlike onboarding: the four offboarding steps are stacked
 * sections on one page rather than tabs, because each is short and an agent
 * works down them in order. There is nothing to select, so nothing to put in
 * the URL beyond which record is open.
 */
export interface OffboardingSearch {
  /** The offboarding being viewed. Absent means the empty state. */
  id?: string | undefined;
}

export function validateOffboardingSearch(
  search: Partial<Record<keyof OffboardingSearch, unknown>> & SearchSchemaInput,
): OffboardingSearch {
  const id =
    typeof search.id === 'string' && search.id.trim().length > 0
      ? search.id.trim()
      : undefined;

  return { id };
}
